import { Component, EventEmitter } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { Observable } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';

import { ContratoService } from '../../../../providers/contrato-service';
import { PessoalService } from '../../../../providers/pessoal-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';
import { RolresponsaveisService } from '../../../../providers/rolresponsaveis-service';
import { ArquivosService } from '../../../../providers/arquivos-service';

import { ModalPessoalTermoReferenciaPage } from '../../../modais/modal-pessoal-termo-referencia/modal-pessoal-termo-referencia';
import { ModalPessoalEvidenciasPage } from '../../../modais/modal-pessoal-evidencia/modal-pessoal-evidencia';
import { ModalArquivosPage } from '../../../modais/modal-arquivos/modal-arquivos';

import { IMyDrpOptions, IMyDateRangeModel, IMyDateRange } from 'mydaterangepicker';

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import { CargoService } from '../../../../providers/cargo-service';

declare var jsPDF: any;

@Component({
    selector: 'page-contratos-terceirizacao',
    templateUrl: 'contratos-terceirizacao.html',
    providers: [
        PessoalService
    ]
})
export class PessoalContratosTerceirizacaolPage extends ModulosController {
    listaDados: any = [];
    listaCargo: any = [];
    listaTiposVinculos: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "112";
    tiposArquivosAceitos: string = "application/xls";
    dadosImportados: any[];
    codigoModulo: any = null;
    codigoModuloContrato: any = null;
    habilita: boolean = true;
    objetoDateRange: any;
    comboContratos: any = null;

    listaContratos: any = [];
    cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    cpfPreenchido: boolean = false;
    cpfCarregado: boolean = true;
    cpfInvalido: boolean = false;

    cnpjPreenchido: boolean = false;
    cnpjCarregado: boolean = true;
    cnpjInvalido: boolean = false;

    loadingContratos: boolean = false;
    loadingEditar: boolean = false;

    page1: number = 1;

    numberMask = createNumberMask({
        prefix: '',
        suffix: '', // This will put the dollar sign at the end, with a space.
        includeThousandsSeparator: false,
        thousandsSeparatorSymbol: '.',
        allowDecimal: false,
        decimalSymbol: ','
    });

    termoParaAdicionar: any = {
        numeroContrato: '',
        dsCredor: '',
        cpf: '',
        cnpj: '',
        objeto: '',
        valorContratado: '',
        inicioVigencia: '',
        fimVigencia: '',
        numeroProtocolo: '',
        nmArquivo: '',
        dsPathArquivo: '',
        dsAtividade: '',
        nomeCargo: ''
    }

    contratoMask = [/[0-9]/, /[0-9]/, /[0-9]/, '/', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/];

    myDateRangePickerOptions: IMyDrpOptions;
    selectedDateRange: IMyDateRange;

    selectedText: string = '';
    border: string = 'none';

    placeholderTxt: string = 'Selecione o Período...';

    typeahead = new EventEmitter<string>();

    objetoEdit: any = null;
    listEdit: any = [];
    analise: any = null;

    desabilitarImportacao = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public pessoalService: PessoalService,
        private fileService: FileService,
        public cargoService: CargoService,
        public gestaoPcaService: GestaoPcaService,
        public rolService: RolresponsaveisService,
        public contratoService: ContratoService,
        private menuService: MenuService,
        public arquivoService: ArquivosService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.analise = this.navParams.get('analise');

        this.myDateRangePickerOptions = {
            dateFormat: 'dd/mm/yyyy',
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            firstDayOfWeek: 'su',
            showApplyBtn: false,
            showClearDateRangeBtn: false,
            selectBeginDateTxt: 'Selecione a Data de Início',
            selectEndDateTxt: 'Selecione a Data de Fim',
            openSelectorOnInputClick: true,
            editableDateRangeField: false,
            width: '100%',
            componentDisabled: true
        };

        if (this.isJurisdicionado) {
            this.codigoModulo = this.navParams.get('analise').idModuloPca;
        }

        this.contratoService.obterModuloPca().subscribe(moduloPca => {
            if(moduloPca) {
                this.codigoModuloContrato = moduloPca.idModuloPca;
            }
            this.carregarDados();
        }, error => {
            console.log(error);
        });

        this.setModuloId(11);

        this.typeahead
            .pipe(distinctUntilChanged(), debounceTime(200), switchMap(term => this.buscarContratos(term)))
            .subscribe(items => {
                this.listaContratos = items;
                this.loadingContratos = false;
            }, (err) => {
                console.log(err);
                this.listaContratos = [];
                this.loadingContratos = false;
            });
    }

    buscarContratos(term: string): Observable<any[]> {
        this.loadingContratos = true;
        return this.contratoService.listarContratosPcaPorNumero(term);
    }

    carregarDados() {
        this.desabilitarImportacao = true;

        this.pessoalService.listarReferenciaContratos().subscribe(data => {
            this.listaDados = data;
            this.desabilitarImportacao = this.listaDados.length > 0;
            this.listaDados.forEach(contrato => {
                this.arquivoService.listarPecasVinculadasPCA(contrato.numeroContrato, this.codigoModuloContrato, '49', false).subscribe(data => {
                    contrato.arquivos = data;
                });
                this.buscarContratos(contrato.numeroContrato).subscribe(items => {
                    if(!(items && items.length > 0)) {
                        contrato.naoCadastrado = true;
                    }
                    this.loadingContratos = false;
                }, (err) => {
                    console.log(err);
                    this.loadingContratos = false;
                });
            });

            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });

        this.cargoService.listarAtivo(11).subscribe(data => {
            this.listaCargo = data;
        }, error => {
            console.log("erro: " + error);
        });
    }

    importarDoAnoAnterior() {

        this.alertService.mostraModalConfirmacao("Importar do Ano Anterior", 
            "Deseja importar os registros do ano anterior?", 
            callback => {            
                if (callback) {
                    this.loading = true;
                    this.desabilitarImportacao = true;                    
                    this.pessoalService.importarReferenciaContratos().subscribe(data => {
                        this.alertService.mostraAlerta("", data.mensagem);
                        this.carregarDados();
                    }, error => {
                        console.log("erro: " + error.mensagem);
                        this.alertService.mostraAlerta("Erro ao importar", error.mensagem);
                        this.carregarDados();
                    });
                }
            }
        );
    } 

    fileChange(event) {
        this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
            if (callback) {
                this.fileService.cargaContratosTerceirizacao(event, this.idSecaoPagina).subscribe(data => {
                    this.dadosImportados = data;

                    for (let j = 0; j < this.dadosImportados.length; j++) {
                        if (this.listaDados.findIndex(i => i.grupoCargo.dsGrupoCargo === this.dadosImportados[j].grupoCargo.dsGrupoCargo) == -1) {
                            this.listaDados.push(this.dadosImportados[j]);
                        }
                    }
                }, error => {
                    this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error);
                    console.log("erro: " + error);
                });
            }
        });
    }

    onCPFAlterado() {
        if (this.validarCPF(this.termoParaAdicionar.cpf)) {
            this.cpfInvalido = false;
        }
        else {
            this.cpfPreenchido = false;
        }
    }

    onCNPJAlterado() {
        if (this.validarCNPJ(this.termoParaAdicionar.cnpj)) {
            this.cnpjInvalido = false;
        }
        else {
            this.cnpjPreenchido = false;
        }
    }

    cpf_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }

    cnpj_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }

    validarCPF(cpf) {
        let ehValido = true;

        cpf = cpf.replace(/[^\w\s]/gi, '');

        if (cpf == '') {
            this.cpfInvalido = false;
            return false;
        }

        if (cpf.length != 11) {
            this.cpfInvalido = false;
            return false;
        }

        // Elimina CPFs invalidos conhecidos
        if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
            cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
            cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
            this.cpfInvalido = true;
            return false;
        }

        // Valida 1o digito
        let add = 0;
        for (let i = 0; i < 9; i++)
            add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(9))) {
            this.cpfInvalido = true;
            return false;
        }

        // Valida 2o digito
        add = 0;
        for (let i = 0; i < 10; i++) {
            add += parseInt(cpf.charAt(i)) * (11 - i);
        }
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(10))) {
            this.cpfInvalido = true;
            return false;
        }

        return ehValido;
    }

    validarCNPJ(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, '');

        if (cnpj == '') {
            this.cnpjInvalido = false;
            return false;
        }

        if (cnpj.length != 14) {
            this.cnpjInvalido = false;
            return false;
        }

        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" ||
            cnpj == "11111111111111" ||
            cnpj == "22222222222222" ||
            cnpj == "33333333333333" ||
            cnpj == "44444444444444" ||
            cnpj == "55555555555555" ||
            cnpj == "66666666666666" ||
            cnpj == "77777777777777" ||
            cnpj == "88888888888888" ||
            cnpj == "99999999999999") {
            this.cnpjInvalido = true;
            return false;
        }

        let tamanho: any;
        let numeros: any;
        let digitos: any;
        let soma: any;
        let pos: any;
        let resultado: any;

        // Valida DVs
        tamanho = cnpj.length - 2
        numeros = cnpj.substring(0, tamanho);
        digitos = cnpj.substring(tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0)) {
            this.cnpjInvalido = true;
            return false;
        }

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1)) {
            this.cnpjInvalido = true;
            return false;
        }

        //this.cnpjInvalido = true;
        return true;
    }

    downloadDoModelo() {
        let idTemplate = 4;

        this.fileService.downloadModeloCargaPessoal(idTemplate);
    }

    adicionarTermo() {
        if (this.termoParaAdicionar.numeroContrato != '' &&
            this.termoParaAdicionar.dsCredor != '' &&
            this.termoParaAdicionar.valorContratado != '' &&
            (this.termoParaAdicionar.cnpj != '' || this.termoParaAdicionar.cpf != '') &&
            this.termoParaAdicionar.inicioVigencia != '' &&
            this.termoParaAdicionar.fimVigencia != '' &&
            this.termoParaAdicionar.objeto != '') {

            let termoNovo = {
                "idReferenciaContratosTerceirizacao": 0,
                "numeroContrato": this.termoParaAdicionar.numeroContrato,
                "numeroProtocolo": this.termoParaAdicionar.numeroProtocolo,
                "arquivos": [],
                "idPca": this.gestaoPcaService.getPCA().id,
                "idModuloAnalise": 0,
                "atividadeTerceirizacoes": [],
                "dsCredor": this.termoParaAdicionar.dsCredor,
                "cpf": this.termoParaAdicionar.cpf,
                "cnpj": this.termoParaAdicionar.cnpj,
                "objeto": this.termoParaAdicionar.objeto,
                "valorContratado": this.termoParaAdicionar.valorContratado,
                "inicioVigencia": this.termoParaAdicionar.inicioVigencia,
                "fimVigencia": this.termoParaAdicionar.fimVigencia
            };

            if (this.listaDados.findIndex(i => i.numeroContrato === termoNovo.numeroContrato) != -1 && !this.objetoEdit) {
                this.alertService.mostraAlerta("", "Contrato já adicionado!");
            }
            else {

                if (this.objetoEdit) {
                    let index = this.listaDados.indexOf(this.objetoEdit);
                    this.listaDados.splice(index, 1);

                    this.listEdit.push(this.objetoEdit);
                }

                this.listaDados.push(termoNovo);

                this.objetoEdit = null;

                this.termoParaAdicionar.numeroContrato =
                    this.termoParaAdicionar.numeroProtocolo =
                    this.termoParaAdicionar.dsCredor =
                    this.termoParaAdicionar.cpf =
                    this.termoParaAdicionar.cnpj =
                    this.termoParaAdicionar.objeto =
                    this.termoParaAdicionar.valorContratado =
                    this.termoParaAdicionar.inicioVigencia =
                    this.termoParaAdicionar.fimVigencia = '';

                    this.comboContratos = null;

                let copy = {
                    dateFormat: 'dd/mm/yyyy',
                    dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
                    monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
                    firstDayOfWeek: 'su',
                    showApplyBtn: false,
                    showClearDateRangeBtn: false,
                    selectBeginDateTxt: 'Selecione a Data de Início',
                    selectEndDateTxt: 'Selecione a Data de Fim',
                    openSelectorOnInputClick: true,
                    editableDateRangeField: false,
                    width: '100%'
                };

                this.myDateRangePickerOptions = copy;
                this.clearDateRange();

                this.salvar(termoNovo);
            }
        }
    }

    removerTermo(termo, edit) {

        if (!edit) {
            this.alertService.mostraModalConfirmacao("Remover Vínculo", "Deseja remover o vínculo?", callback => {
                if (callback) {

                    let index = this.listaDados.indexOf(termo);
                    this.listaDados.splice(index, 1);

                    if (termo.idReferenciaContratosTerceirizacao != 0) {
                        this.deletarReferenciaContrato(termo.idReferenciaContratosTerceirizacao);
                    }
                }
            });
        } else {
            // let index = this.listaDados.indexOf(termo);
            // this.listaDados.splice(index, 1);

            if (termo.idReferenciaContratosTerceirizacao != 0) {
                this.deletarReferenciaContrato(termo.idReferenciaContratosTerceirizacao);
            }
        }
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaPessoal() {
        this.menuService.redirecionarPagina(this.pessoalService.obterIdPaginaPessoal());
    }

    salvar(contrato:any) {

        this.listEdit = [];

        let lista = [];

        if(contrato){
            lista.push(contrato);
        } else {
            lista = this.listaDados;
        }

        for (let j = 0; j < lista.length; j++) {

            if (lista[j].cnpj != null && lista[j].cnpj != undefined && lista[j].cnpj != '') {
                lista[j].cnpj = lista[j].cnpj.replace(/[^\d]+/g, '');
            } else if (lista[j].cpf != null && lista[j].cpf != undefined && lista[j].cpf != '') {
                lista[j].cpf = lista[j].cpf.replace(/[^\w\s]/gi, '');
            }
        }

        this.pessoalService.salvarReferenciaContratos(lista, this.idSecaoPagina).subscribe(() => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.carregarDados();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar: " + error.mensagem);
        });
    }

    deletarReferenciaContrato(idReferenciaContratosTerceirizacao) {
        this.pessoalService.deletarReferenciaContratos(idReferenciaContratosTerceirizacao).subscribe(data => {
            this.carregarDados();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir:" + error);
            this.carregarDados();
        })
    }

    finalizar() {
        this.listEdit = [];

        let semAtribuicao = false;

        if (this.listaDados) {
            this.listaDados.forEach(item => {
                if(!item.atividadeTerceirizacoes || item.atividadeTerceirizacoes.length == 0){
                    semAtribuicao = true;                   
                    return;
                }
            });

            if(semAtribuicao){
                this.alertService.mostraAlerta("", "Contratro(s) sem atribuição.");
                return;
            }

            this.pessoalService.finalizarReferenciaContratos(this.listaDados, this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                this.voltarParaPessoal();
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
            });
        }
    }

    modalAtividades(item) {
        this.apresentaModalAtividades("Atribuições", item, ModalPessoalTermoReferenciaPage);
    }

    apresentaModalAtividades(titulo: String, objeto: any, modalPage: any) {
        let modal = this.modalCtrl.create(modalPage, { param1: titulo, objeto: objeto, isCGE: this.isCGE, analise: this.analise });
        modal.onDidDismiss(retornoModal => {
        });
        modal.present();
    }

    modalEvidencias(item) {
        this.apresentaModalEvidencias("Documentos", item, ModalPessoalEvidenciasPage);
    }

    apresentaModalEvidencias(titulo: String, objeto: any, modalPage: any) {
        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: objeto.numeroContrato,
                idModuloPCA: this.codigoModuloContrato,
                tipoAnalise: '49',
                jurisdicionado: false,
                isCGE: false,
                origemArquivo: "Contrato: " + objeto.numeroContrato,
                origemFilter: 'PESSOAL',
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,       
                analise: this.analise,
                flPegaDocumentoDoModuloDeContrato: true
            });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal && retornoModal.flag) {
            }
        });

        modal.present();
    }

    editar(item) {
        // this.termoParaAdicionar.numeroContrato = item.numeroContrato;        
        // this.termoParaAdicionar.dsCredor = item.dsCredor;
        // this.termoParaAdicionar.cnpj = item.cnpj;
        // this.termoParaAdicionar.cpf = item.cpf;
        // this.termoParaAdicionar.valorContratado = item.valorContratado;        

        // let inicio = item.inicioVigencia.split("/");
        // let fim = item.fimVigencia.split("/");

        // this.selectedDateRange = { beginDate: { year: inicio[2], month: inicio[1], day: inicio[0] }, endDate: { year: fim[2], month: fim[1], day: fim[0] } };
        
        // this.comboContratos = item.numeroContrato;

        // this.onContratoChange(this.comboContratos);

        this.loadingEditar = true;
        this.buscarContratos(item.numeroContrato).subscribe(items => {

            if(items && items.length > 0) {
                this.listaContratos = items;
                this.comboContratos = items[0];
                
                this.termoParaAdicionar.dsCredor = this.comboContratos.credor;
    
                if (this.comboContratos.cnpj != null && this.comboContratos.cnpj != undefined && this.comboContratos.cnpj != '') {
                    this.termoParaAdicionar.cnpj = this.comboContratos.cnpj;
                    this.habilita = true;
                } else if (this.comboContratos.cpf != null && this.comboContratos.cpf != undefined && this.comboContratos.cpf != '') {
                    this.termoParaAdicionar.cpf = this.comboContratos.cpf;
                    this.habilita = false;
                }
                
                this.termoParaAdicionar.inicioVigencia = this.comboContratos.inicioVigencia;
                this.termoParaAdicionar.fimVigencia = this.comboContratos.novaDataVigencia;
                this.termoParaAdicionar.valorContratado = this.comboContratos.valorInicial;
                this.termoParaAdicionar.objeto = this.comboContratos.objeto;
                this.termoParaAdicionar.numeroContrato = this.comboContratos.nmContrato;
    
                this.objetoDateRange = {
                    beginDate: { year: this.termoParaAdicionar.inicioVigencia.split("/")[2], month: this.termoParaAdicionar.inicioVigencia.split("/")[1].replace(/^0+/, ''), day: this.termoParaAdicionar.inicioVigencia.split("/")[0].replace(/^0+/, '') },
                    endDate: { year: this.termoParaAdicionar.fimVigencia.split("/")[2], month: this.termoParaAdicionar.fimVigencia.split("/")[1].replace(/^0+/, ''), day: this.termoParaAdicionar.fimVigencia.split("/")[0].replace(/^0+/, '') }
                };
            } else {
                item.naoCadastrado = true;
                this.alertService.mostraAlerta("", "Contrato não cadastrado nesta PCA.");
            }

            this.loadingEditar = false;
            this.loadingContratos = false;
        }, (err) => {
            console.log(err);
            this.alertService.mostraAlerta("Houve um erro ao carregar o contrato", err.mensagem);
            this.listaContratos = [];
            this.loadingEditar = false;
            this.loadingContratos = false;
        });

        // this.loadingContratos = false;
        this.objetoEdit = item;
    }

    printData() {

        var doc = new jsPDF("l");
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // HEADER
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle('normal');

            doc.text("Pessoal - Termo de Referência de Contratos de Terceirização", data.settings.margin.left + 15, 22);

            // FOOTER
            var str = "Page " + data.pageCount;
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp;
            }
            doc.setFontSize(10);
            doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        };

        var columns = [
            { title: "Nº do Contrato SACC/SCC", dataKey: "numeroContrato" },
            { title: "Contrato Enviado?", dataKey: "arquivoContrato" },
            { title: "Atribuições Preenchidas", dataKey: "atribuicao" }
        ];

        let rows = [];

        this.listaDados.forEach(contrato => {
            let enviadoContrato;
            let atribuicao;

            enviadoContrato = contrato.arquivos && contrato.arquivos.length > 0 ? "Sim" : "Não";

            if (contrato.atividadeTerceirizacoes.length == 0) {
                atribuicao = "Não";
            } else {
                atribuicao = "Sim";
            }

            var item = {
                "numeroContrato": contrato.numeroContrato,
                "arquivoContrato": enviadoContrato,
                "atribuicao": atribuicao
            };

            rows.push(item);
        });

        doc.autoTable(columns, rows, {
            theme: 'grid',
            addPageContent: pageContent,
            margin: { top: 30 },
            styles: {
                overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
                columnWidth: 'auto'
            }
        });

        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        doc.save('pessoal_termo_referencia.pdf');
    }

    onDateRangeChanged(event: IMyDateRangeModel) {

        if (event.formatted !== '') {

            this.border = '1px solid #CCC';

            this.termoParaAdicionar.inicioVigencia = new Date(event.beginJsDate).toLocaleDateString('pt-br');
            this.termoParaAdicionar.fimVigencia = new Date(event.endJsDate).toLocaleDateString('pt-br');

            if (+this.termoParaAdicionar.inicioVigencia.split("/")[2] > this.PCAAtiva.dsAnoexercicio) {
                this.termoParaAdicionar.inicioVigencia = '';
                this.termoParaAdicionar.fimVigencia = '';
                this.clearDateRange();
                this.alertService.mostraAlerta("", "A Vigência do Contrato de Gestão não pode ser superior ao exercício da Prestação de Contas.");
            }
        }
        else {
            this.selectedText = '';
            this.border = 'none';
        }
    }

    clearDateRange(): void {
        this.selectedDateRange = null;
    }

    onContratoChange(contrato) {

        if (contrato != null && contrato != undefined) {
            console.log(contrato.novaDataVigencia)

            this.termoParaAdicionar.dsCredor = contrato.credor;

            if (contrato.cnpj != null && contrato.cnpj != undefined && contrato.cnpj != '') {
                this.termoParaAdicionar.cnpj = contrato.cnpj;
                this.habilita = true;
            } else if (contrato.cpf != null && contrato.cpf != undefined && contrato.cpf != '') {
                this.termoParaAdicionar.cpf = contrato.cpf;
                this.habilita = false;
            }

            this.termoParaAdicionar.inicioVigencia = contrato.inicioVigencia;
            this.termoParaAdicionar.fimVigencia = contrato.novaDataVigencia;
            this.termoParaAdicionar.valorContratado = contrato.valorInicial;
            this.termoParaAdicionar.objeto = contrato.objeto;
            this.termoParaAdicionar.numeroContrato = contrato.nmContrato;

            this.objetoDateRange = {
                beginDate: { year: this.termoParaAdicionar.inicioVigencia.split("/")[2], month: this.termoParaAdicionar.inicioVigencia.split("/")[1].replace(/^0+/, ''), day: this.termoParaAdicionar.inicioVigencia.split("/")[0].replace(/^0+/, '') },
                endDate: { year: this.termoParaAdicionar.fimVigencia.split("/")[2], month: this.termoParaAdicionar.fimVigencia.split("/")[1].replace(/^0+/, ''), day: this.termoParaAdicionar.fimVigencia.split("/")[0].replace(/^0+/, '') }
            };
        } else {
            this.termoParaAdicionar.dsCredor = '';
            this.termoParaAdicionar.cnpj = '';
            this.termoParaAdicionar.cpf = '';
            this.termoParaAdicionar.inicioVigencia = '';
            this.termoParaAdicionar.fimVigencia = '';
            this.termoParaAdicionar.valorContratado = '';
            this.termoParaAdicionar.objeto = '';
            this.termoParaAdicionar.numeroContrato = '';

            this.clearDateRange();
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/pessoal/contratos-terceirizacao/contratos-terceirizacao.ts